
import classes from './PushCancel.module.scss';
import signpost from '../../../../../assets/img/signpost.svg';
import Ajax from '../../../../../Handler/Ajax';
import Toast from '../../../../Form/Toast';
import { useState } from 'react';

declare var _loginMethodSmsOtpUrl: any;
declare function Translate(key: string): string;


const PushCancel = () => {

    const [serverMessage,setServerMessage] = useState('');
    
    const backToMainClick = () => {
        Ajax.ResetUserStatus()
            .then(() => {                                  
                window.location = _loginMethodSmsOtpUrl;
            })
            .catch((error) => {                                  
                setServerMessage(Translate(error) !== '' ? Translate(error) : Translate('N_General_Error_SYSTEM_ERROR'));          
            });
    };

    const backToMainPress = (event) => {
        event.preventDefault();
        if (event.charCode === 13){
            backToMainClick();
        }
    };

    return(
         <div className={classes.main}>
            {serverMessage.length > 0 && (
                <Toast message={serverMessage} />
            )}

            <img src={signpost} className={classes.img} alt="" />
            <div className={classes.title}>
                 <span>{Translate('N_General_unibeam_54')}</span>     
            </div>
            <div className={classes.desc}>
               <span>{Translate('N_General_unibeam_55')}</span>      
            </div>
            <div className={classes.subMain}>
                <div className={classes.confirm}>
                    <span>{Translate('N_General_unibeam_56')}</span>&nbsp;
                    <span className={classes.bold}>{Translate('N_General_unibeam_57')}</span>&nbsp;
                    <span>{Translate('N_General_unibeam_58')} </span>&nbsp;                    
                    <span>{Translate('N_General_unibeam_59')}</span>&nbsp;
                </div>
                <div className={classes.buttonContainer}>
                    <button
                        id='backToLoginBtn' 
                        className={classes.button} 
                        onClick={backToMainClick}
                        onKeyPress={backToMainPress}
                    >{Translate('N_General_unibeam_60')}</button>
                </div>
                <hr />
                <div className={classes.bottom}>
                    <div className={classes.bottomTitle}>{Translate('N_General_unibeam_6')}</div>
                    <div>{Translate('N_General_unibeam_7')}</div>
                    <a  id='backToLoginLink' 
                        className={classes.backLink} 
                        onClick={backToMainClick}
                        onKeyPress={backToMainPress}
                        tabIndex={0}               
                    >
                        {Translate('N_General_unibeam_8')}
                    </a>       
                </div>
            </div>

            
        </div>
    );
};
export default PushCancel;